import {Ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribClass} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreGroup} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Group';
import {attribClassClassObject, BuildHeaders, BuildTableData} from './Common';
import {
	primitives,
	primitiveAttribNamesFromCoreGroup,
	primitiveAttribSizesFromCoreGroup,
	primitiveAttribTypesFromCoreGroup,
} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/entities/primitive/CorePrimitiveUtils';
import {CoreObjectType} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/ObjectContent';
import {CorePrimitive} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/entities/primitive/CorePrimitive';

interface SetupForPrimitiveOptions {
	selectedAttribClass: Ref<AttribClass>;
	primitiveAttribNames: Ref<string[]>;
	buildHeaders: BuildHeaders;
	buildTableData: BuildTableData;
}

export function SetupForPrimitive(options: SetupForPrimitiveOptions) {
	const {selectedAttribClass, primitiveAttribNames, buildHeaders, buildTableData} = options;

	const classObjectPrimitiveButton = computed(() => {
		return attribClassClassObject(selectedAttribClass.value == AttribClass.PRIMITIVE);
	});
	function setAttribClassPrimitive() {
		selectedAttribClass.value = AttribClass.PRIMITIVE;
	}

	//
	//
	// POINTS
	//
	//
	const _primitives: CorePrimitive<CoreObjectType>[] = [];
	function build(coreGroup: CoreGroup) {
		primitiveAttribNames.value = primitiveAttribNamesFromCoreGroup(coreGroup);
		const attribSizes = primitiveAttribSizesFromCoreGroup(coreGroup);
		const attribTypes = primitiveAttribTypesFromCoreGroup(coreGroup);
		const attrib_types_by_name: PolyDictionary<AttribType> = {};
		for (let name of primitiveAttribNames.value) {
			const type = attribTypes[name];
			if (type) {
				attrib_types_by_name[name] = type;
			}
		}
		buildHeaders(primitiveAttribNames.value, attribSizes, attrib_types_by_name);
		buildTableData(primitives(coreGroup, _primitives), primitiveAttribNames.value, attribSizes);
	}

	return {
		classObjectPrimitiveButton,
		setAttribClassPrimitive,
		build,
	};
}
